import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { PRESS } from "@/data/content";

export const PressArticleCard = ({ article, index }) => (
  <Reveal delay={index * 0.08}>
    <article
      data-testid={`press-article-${index + 1}`}
      className="flex flex-col gap-8 rounded-xl border border-slate-100 bg-white p-8 transition-shadow hover:shadow-xl md:flex-row md:items-center md:justify-between md:p-12"
    >
      <div className="max-w-2xl">
        <p className="text-xs font-semibold uppercase tracking-widest text-navy">
          {article.kicker}
        </p>
        <h3 className="mt-3 font-display text-2xl font-bold uppercase leading-tight tracking-tight text-ink sm:text-3xl">
          {article.headline}
        </h3>
        <p className="mt-3 text-sm text-slate-500">{article.byline}</p>
        <p className="mt-4 text-sm leading-relaxed text-slate-600 md:text-base">
          {article.summary}
        </p>
      </div>
      <a
        href={article.url}
        target="_blank"
        rel="noopener noreferrer"
        data-testid={`press-article-link-${index + 1}`}
        className="group inline-flex w-fit shrink-0 items-center gap-2 text-sm font-semibold text-navy transition-colors hover:text-navy-dark"
      >
        {article.cta}
        <ArrowUpRight
          size={16}
          className="transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5"
        />
      </a>
    </article>
  </Reveal>
);

export const InTheNews = () => (
  <section
    data-testid="in-the-news-section"
    className="border-t border-slate-100 bg-white py-16 md:py-24"
  >
    <div className="mx-auto w-full max-w-7xl px-6 md:px-12">
      <Reveal>
        <p className="text-xs font-semibold uppercase tracking-widest text-navy">
          {PRESS.eyebrow}
        </p>
        <h2 className="mt-4 font-display text-4xl font-bold uppercase leading-[1.05] tracking-tight text-ink sm:text-5xl">
          {PRESS.heading}
        </h2>
      </Reveal>

      <div className="mt-14">
        {PRESS.articles.map((article, i) => (
          <PressArticleCard key={article.url} article={article} index={i} />
        ))}
      </div>
    </div>
  </section>
);
